import feathersClient, {makeServicePlugin, BaseModel} from '../../feathers-client'

class EventGuest extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'EventGuest';

    // Define default properties here
    static instanceDefaults() {
        return {
            eventId: null,
            guestId: null,
        }
    }

    // static setupInstance(data, { models }) {
    //     if (data.EventGuest) {
    //         data.EventGuest = new models.api.EventGuest(data.EventGuest)
    //     }
    //     return data
    // }
}

const servicePath = 'event-guests';
const servicePlugin = makeServicePlugin({
    Model: EventGuest,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin